import { ServiceBase } from "./ServiceBase";
import { ShoppingCart, ShoppingCartItem, ShoppingCartSettings } from "../models/ShoppingCart";
import { strict } from "assert";
import { string } from "yup";
import { PagedResult } from "../models/Results";
import { ImpactPartner } from "../models/ImpactPartner";

export default class CartService extends ServiceBase {

    /*public static async sendOrder(payload: {
        orderLines: ProductOrderLine[],
        htmlBody:string}
    ): Promise<Result<{}>> {

        var result = await this.requestJson<{}>({
            url: `/api/Cart/SendOrder`,
            method: "POST",
            data: payload
        });

        return result;
    }*/

    public static async getSettings() {
        let response = await this.requestJson<ShoppingCartSettings>({
            url: `/api/Cart/settings`,
            method: "GET"
        });

        return response;
    }

    public static async markCartProcessed(cartId: string) {

        var result = await this.requestJson({
            url: `/api/Cart/MarkProcessed?cartId=${cartId}`,
            method: "POST"
        });

        return result;
    }

    public static async addToCart(
        userId: string,
        impactPartnerId: string,
        cartId: string,
        cartName: string,
        item: ShoppingCartItem) {

        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/AddToCart`,
            method: "POST",
            data: {
                userId, impactPartnerId, cartId, cartName, item
            }
        });

        return response;
    }

    public static async removeFromCart(cartItemId: string, userId: string) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/RemoveFromCart`,
            method: "POST",
            data: { cartItemId, userId }
        });

        return response;
    }

    public static async removePartnerItemsFromCart(cartId: string, partnerId: string, userId: string) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/cart/partner/removeItemsFromCart`,
            method: "POST",
            data: { cartId, partnerId, userId }
        });

        return response;
    }

    public static async updateQuantity(cartItemId: string, userId: string, amount: number, approvedBy?: string) {
        let response = await this.requestJson<ShoppingCartItem>({
            url: `/api/Cart/UpdateQuantity`,
            method: "POST",
            data: { userId, cartItemId, amount, approvedBy }
        });

        return response;
    }

    public static async getCarts(userId: string, impactPartnerId: string, pageIndex: number, pageSize: number) {
        let response = await this.requestJson<PagedResult<ShoppingCart>>({
            url: `/api/Cart/GetUserCarts`,
            method: "POST",
            data: { userId, impactPartnerId, pageIndex, pageSize }
        });

        return response;
    }

    public static async getCartsTotalQty(userId: string, impactPartnerId: string) {
        let response = await this.requestJson<number>({
            url: `/api/Cart/GetUserCartsTotalQty`,
            method: "POST",
            data: { userId, impactPartnerId }
        });

        return response;
    }

    public static async getCart(userId: string, impactPartnerId: string, cartId) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/${cartId}`,
            method: "POST",
            data: { userId, impactPartnerId }
        });

        return response;
    }

    public static async getLookupCarts(userId: string, impactPartnerId: string, excludeCartId: string, addCreateCartOption: boolean) {
        let response = await this.requestJson<ShoppingCart[]>({
            url: `/api/Cart/lookups`,
            method: "POST",
            data: { userId, impactPartnerId, excludeCartId, addCreateCartOption }
        });

        return response;
    }

    public static async createNewCart(cartName: string, userId: string, impactPartnerId: string) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/Create`,
            method: "POST",
            data: {
                cartName, userId, impactPartnerId
            }
        });

        return response;
    }

    public static async editCartName(cartId: string, cartName: string, userId: string, impactPartnerId: string) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/EditCartName`,
            method: "POST",
            data: {
                cartId,
                cartName,
                userId,
                impactPartnerId
            }
        });

        return response;
    }

    public static async deleteCart(cartId: string, userId: string) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/${cartId}`,
            method: "DELETE"
        });

        return response;
    }

    public static async moveCartItem(destinationCartId: string, cartItemId: string) {
        let response = await this.requestJson({
            url: `/api/Cart/MoveCartItem`,
            method: "POST",
            data: { destinationCartId, cartItemId }
        });

        return response;
    }

    public static async cartsMerge(cartIds: string[], cartName: string, userId: string, impactPartnerId: string) {
        let response = await this.requestJson<ShoppingCart>({
            url: `/api/Cart/MergeCarts`,
            method: "POST",
            data: {
                cartIds,
                cartName,
                userId,
                impactPartnerId
            }
        });

        return response;
    }

    public static async sendOrder(cartID: string, userId: string, impactPartner: ImpactPartner) {
        let response = await this.requestClietAuthJson<any>(impactPartner, {
            url: `/api/Cart/sendCartOrder/${cartID}`,
            method: "POST",
            data: {
                userId, impactPartnerId: impactPartner.Id
            }
        });

        return response;
    }
}

export class SendAllOrdersResult {
    SuccessOrderIds: string[];
    FailedOrderIds: string[];
}